import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const SignInPage = lazy(() => import('./pages/signIn'))
const SignUpPage = lazy(() => import('./pages/signUp'))
const SetupProfilePage = lazy(() => import('./pages/setupProfile'))
const InvitationPage = lazy(() => import('./pages/invitation'))
const ForgotPassword = lazy(() => import('./pages/resetPassword'))
export const authRoutesPublic = () => {
  return (
    <>
      <Route path={pageUrl.signIn} element={<SignInPage />} />
      <Route path={pageUrl.signUp} element={<SignUpPage />} />
      <Route path={pageUrl.invitation} element={<InvitationPage />} />
      <Route path={pageUrl.resetPassword} element={<ForgotPassword />} />
    </>
  )
}

export const authRoutesAdmin = () => {
  return (
    <>
      <Route path={pageUrl.setupProfile} element={<SetupProfilePage />} />
    </>
  )
}
